import CreatableSelect from 'react-select/creatable';
import { Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import DebtRow from '../debt-row/DebtRow';

const  BudgetForm = (props) => {

  const calculateMonthTotal = total => {
    if(props.debtData!==undefined) {
      if (!props.debtData.manual) {
        total = +total + +props.debtData.totalPerMonthOverall;
      } else {
        total = +total + +props.debtData.totalPerMonthIndividual;
      }
    }
    return +total;
  }

  const calculateWeekTotal = total => {
    if(props.debtData!==undefined) {
      if (!props.debtData.manual) {
        total = +total + +props.debtData.totalPerWeekOverall;
      } else {
        total = +total + +props.debtData.totalPerWeekIndividual;
      }
    }
    return total;
  }

  return (
    <Row className="budget-form">
      <h2>{props.title}</h2>
      <Form>
      <div className="scroll-row-wrapper">
      <Row className="scroll-row" >
      {props.data.records.map((field, index) => (
        <Row key={field.id || index} className='item-row'>
          <Col xs={12} md={5} lg={4}>
            <Form.Label htmlFor={'type-'+index}>Description</Form.Label>
            <CreatableSelect
              key={'type-'+index}
              id={'type-'+index}
              isClearable
              className="react-select-style"
              onChange={(event) => {
                props.handleChange(index, event, props.yearCalc);
              }}
              onCreateOption={(e) => props.handleCreateDescription(e, index, props.category)}
              options={props.data.descriptions}
              value={{'label':field.description}}
            />
          </Col>
          <Col xs={12} md={5} lg={4}>
            <Form.Label htmlFor={'company-'+index}>Company</Form.Label>
            <Form.Control
              key={'company-'+index}
              id={'company-'+index}
              type="text"
              name="company"
              placeholder="Company (Optional)"
              value={field.company}
              onChange={(event) => {
                props.handleChange(index, event, props.yearCalc);
              }}
            />
          </Col>
          <Col  xs={12} md={5} lg={2}>
            <Form.Label htmlFor={'monthly-'+index}>Monthly</Form.Label>
            <InputGroup>
              <InputGroup.Text>£</InputGroup.Text>
                <Form.Control
                  key={'monthly-'+index}
                  id={'monthly-'+index}
                  type="number"
                  name="monthlyAmount"
                  placeholder="Enter Amount"
                  value={field.monthlyAmount}
                  onBlur={(event) => {props.handleUpdate(index, event)}}
                  onChange={(event) => {
                    props.handleChange(index, event, props.yearCalc);
                  }}
                />
              </InputGroup>
          </Col>
          <Col xs={12} md={5} lg={2}>
            <Form.Label htmlFor={'weekly-'+index}>Weekly</Form.Label>
            <InputGroup>
              <InputGroup.Text>£</InputGroup.Text>
              <Form.Control
                key={'weekly-'+index}
                id={'weekly-'+index}
                type="number"
                name="weeklyAmount"
                placeholder="Enter Amount"
                value={field.weeklyAmount}
                onBlur={(event) => {props.handleUpdate(index, event, props.yearCalc)}}
                onChange={(event) => {
                  props.handleChange(index, event, props.yearCalc);
                }}
              />
            </InputGroup>
          </Col>
          <Col xs={12} className="record-actions">
            {props.data.records.length > 1?
              <Button type="button" variant="outline-danger" className="record-action-button"
                onClick={() => props.handleRemove(index, props.yearCalc)}>
                Remove {props.title}
              </Button>:<></>}
            <Button type="button" variant="outline-primary" className="record-action-button"
              onClick={() => props.handleAdd(index + 1)}>
              Add {props.title}
            </Button>
          </Col>
        </Row>
      ))}
        {props.debtData!==undefined && props.debtData.totalPerMonthOverall > 0?
          <DebtRow debtData={props.debtData}/>:<></>
        }
      </Row>
      </div>
        <Row>
          <Row>
            <Col  xs={11} md={5} lg={8} className="total-text">
              Total {props.title}
            </Col>
            <Col  xs={11} md={5} lg={2} className="total-text">
              £{Number(calculateMonthTotal(props.data.monthlyTotal)).toFixed(2)}
            </Col>
            <Col  xs={11} md={5} lg={2} className="total-text">
              £{Number(calculateWeekTotal(props.data.weeklyTotal)).toFixed(2)}
            </Col>
          </Row>
        </Row>
      </Form>
    </Row>
  );
}

export default BudgetForm;